<div class="header-bridge" aria-hidden="true"></div>
<audio #aiAudio hidden></audio>
<audio #soundEffectAudio hidden></audio>

<!-- 準備画面 -->
@if (view === 'PREPARE') {
  <div class="page prepare">
    <div class="prepare-stack">
      @if (micPermissionDenied$ | async) {
        <div class="alert-error" role="alert">
          {{ (permissionErrorMsg$ | async) || 'マイクの権限がありません。' }}
        </div>
      }
      <section class="card">
        <!-- セッション設定 -->
        <div class="session-config">
          <div class="field">
            <label class="field-label" for="persona-select">ペルソナ選択</label>
            <select
              id="persona-select"
              class="select-control"
              [(ngModel)]="selectedPersonaId"
              (ngModelChange)="onPersonaChange($event)"
              [disabled]="isConnecting"
            >
              @for (persona of personas; track persona) {
                <option [ngValue]="persona.id">
                  {{ persona.name }}
                </option>
              }
            </select>
          </div>
          @if (selectedPersona; as p) {
            <app-persona-briefing [persona]="p" />
          }
        </div>
        <!-- メインボタン -->
        <div class="actions center">
          <button
            #startBtn
            class="start"
            type="button"
            [disabled]="
              isConnecting || ((micPermissionDenied$ | async) ?? false)
            "
          >
            対話開始
          </button>
        </div>
      </section>
      <!-- カード外設定と関連する部分 -->
      <div class="device-row">
        <div class="dev">
          <div class="tool">
            <span>🎙️</span>
            <select
              class="select-compact"
              [disabled]="
                isConnecting || ((micPermissionDenied$ | async) ?? false)
              "
              [ngModel]="(selectedMicId$ | async) ?? ''"
              (ngModelChange)="onMicChange($event)"
              aria-label="マイク選択"
            >
              <option [ngValue]="''">システム既定</option>
              @for (d of (mics$ | async) ?? []; track d) {
                <option [ngValue]="d.deviceId">
                  {{ d.label || 'マイク' }} ({{ d.deviceId | slice: 0 : 6 }})
                </option>
              }
            </select>
            <button
              class="ghost sm"
              type="button"
              (click)="micTestRunning ? stopTestMic() : testMic()"
              [disabled]="
                isConnecting ||
                isSwitchingMic ||
                ((micPermissionDenied$ | async) ?? false)
              "
              [attr.aria-label]="
                micTestRunning ? 'マイクテストを停止' : 'マイクテストを開始'
              "
            >
              {{ micTestRunning ? '停止' : 'テスト' }}
            </button>
            <div class="mic-level" aria-hidden="true">
              <div
                class="mic-level_fill"
                [style.transform]="'scaleX(' + (rms || 0) + ')'"
              ></div>
            </div>
          </div>
          @if (sinkCapable) {
            <div class="tool">
              <span>🔊 </span>
              <select
                class="select-compact"
                [disabled]="
                  isConnecting || ((micPermissionDenied$ | async) ?? false)
                "
                [ngModel]="(selectedSpeakerId$ | async) ?? ''"
                (ngModelChange)="onSpeakerChange($event)"
                aria-label="スピーカー選択"
              >
                <option [ngValue]="''">システム既定</option>
                @for (d of (speakers$ | async) ?? []; track d) {
                  <option [ngValue]="d.deviceId">
                    {{ d.label || 'スピーカー' }} ({{
                      d.deviceId | slice: 0 : 6
                    }})
                  </option>
                }
              </select>
              <button
                class="ghost sm"
                type="button"
                (click)="testSpeaker()"
                [disabled]="
                  isConnecting || ((micPermissionDenied$ | async) ?? false)
                "
                aria-label="スピーカーテスト"
              >
                テスト
              </button>
            </div>
          }
          <!-- [SUBTITLES-START] 準備画面：字幕トグル（非表示） -->
          <!--
          <div class="tool">
            <span>字幕 </span>
            <label class="switch">
              <input type="checkbox" [checked]="captionsEnabled" (change)="onToggleCaptions($event)">
              <span class="slider"></span>
            </label>
          </div>
          -->
          <!-- [SUBTITLES-END] -->
        </div>
      </div>
      <app-active-session-count></app-active-session-count>
    </div>
  </div>
}

<!-- 会話画面 -->
@if (view === 'DIALOG') {
  <div class="stage view-container" [class.transitioning]="isTransitioning">
    @if (captionsFeatureEnabled) {
      <button
        class="cc-btn"
        type="button"
        [class.off]="!captionsEnabled"
        (click)="onToggleCaptions()"
        [attr.aria-pressed]="captionsEnabled"
        [attr.aria-label]="captionsEnabled ? '字幕ON' : '字幕OFF'"
      >
        CC
      </button>
    }
    <button
      class="end-btn"
      type="button"
      (click)="onEndClick()"
      aria-label="対話終了"
    >
      <span class="end-btn-text">対話終了</span>
    </button>
    @if (state === 'AI_SPEAKING' && showWaveformDebug) {
      <button
        class="stop-ai-btn"
        type="button"
        (click)="onStopAiSpeaking()"
        aria-label="AI発話停止"
      >
        <span class="stop-ai-btn-text">⏸ AI停止</span>
      </button>
    }
    <!-- 評価表示コンポーネント（アドオン動的注入） -->
    @if (sessionAssessmentComponent && currentAssessment) {
      <ng-container
        *ngComponentOutlet="
          sessionAssessmentComponent;
          inputs: { assessment: currentAssessment }
        "
      ></ng-container>
    }
    <!-- 通常モード: 単一アバター -->
    @if (!isGroupSession) {
      <div
        class="avatar-container"
        [class.user]="state === 'USER_SPEAKING' || state === 'LISTENING'"
        [class.processing]="state === 'PROCESSING'"
        [class.ai]="state === 'AI_SPEAKING'"
      >
        <button
          type="button"
          class="avatar-button"
          (click)="onAvatarTap()"
          aria-label="アバターをタップして対話"
        >
          <img
            [src]="avatarImage"
            alt="対話相手"
            class="avatar-image"
            [class.speaking]="state === 'AI_SPEAKING'"
            [class.listening]="
              state === 'USER_SPEAKING' || state === 'LISTENING'
            "
            [class.thinking]="state === 'PROCESSING'"
          />
        </button>
      </div>
    }
    <!-- 2者通話モード: 親子アバター -->
    @if (isGroupSession) {
      <div
        class="dual-avatar-container"
        [class.user]="state === 'USER_SPEAKING' || state === 'LISTENING'"
        [class.processing]="state === 'PROCESSING'"
        [class.ai]="state === 'AI_SPEAKING'"
      >
        <!-- 親（母）アバター -->
        <button
          type="button"
          class="avatar-button parent-avatar"
          [class.active]="currentSpeaker === '母'"
          [class.inactive]="currentSpeaker === '子'"
          (click)="onAvatarTap()"
          aria-label="親アバター"
        >
          <img
            [src]="avatarImage"
            alt="親"
            class="avatar-image"
            [class.speaking]="
              state === 'AI_SPEAKING' && currentSpeaker === '母'
            "
            [class.listening]="
              state === 'USER_SPEAKING' || state === 'LISTENING'
            "
            [class.thinking]="state === 'PROCESSING'"
          />
        </button>
        <!-- 子アバター -->
        <button
          type="button"
          class="avatar-button child-avatar"
          [class.active]="currentSpeaker === '子'"
          [class.inactive]="currentSpeaker === '母'"
          (click)="onAvatarTap()"
          aria-label="子アバター"
        >
          <img
            [src]="childAvatarImage"
            alt="子"
            class="avatar-image"
            [class.speaking]="
              state === 'AI_SPEAKING' && currentSpeaker === '子'
            "
            [class.listening]="
              state === 'USER_SPEAKING' || state === 'LISTENING'
            "
            [class.thinking]="state === 'PROCESSING'"
          />
        </button>
      </div>
    }
    <!-- 音声波形デバッグ表示 -->
    @if (showWaveformDebug && audioAnalyzerService.audioSettings) {
      <div class="waveform-debug-container">
        <canvas
          #waveformCanvas
          class="waveform-debug"
          width="512"
          height="200"
          aria-hidden="true"
        ></canvas>
        <div class="waveform-controls">
          <div class="control-group">
            <span class="control-label">VAD閾値:</span>
            <button
              type="button"
              class="threshold-btn"
              (click)="adjustVADSensitivity(-2)"
              title="閾値を下げる（より敏感に）"
            >
              -
            </button>
            <span class="threshold-value">{{
              vadSettings.silenceThreshold
            }}</span>
            <button
              type="button"
              class="threshold-btn"
              (click)="adjustVADSensitivity(2)"
              title="閾値を上げる（鈍感に）"
            >
              +
            </button>
          </div>
          <div class="control-group">
            <span class="control-label">最小発話:</span>
            <button
              type="button"
              class="threshold-btn"
              (click)="adjustMinSpeechDuration(-100)"
              title="最小発話時間を短く"
            >
              -
            </button>
            <span class="threshold-value"
              >{{ vadSettings.minSpeechDuration }}ms</span
            >
            <button
              type="button"
              class="threshold-btn"
              (click)="adjustMinSpeechDuration(100)"
              title="最小発話時間を長く"
            >
              +
            </button>
            <span class="control-label separator">無音検出:</span>
            <button
              type="button"
              class="threshold-btn"
              (click)="adjustSilenceDuration(-200)"
              title="無音検出時間を短く"
            >
              -
            </button>
            <span class="threshold-value"
              >{{ vadSettings.silenceDuration }}ms</span
            >
            <button
              type="button"
              class="threshold-btn"
              (click)="adjustSilenceDuration(200)"
              title="無音検出時間を長く"
            >
              +
            </button>
          </div>
          <div class="control-group">
            <button
              type="button"
              class="setting-toggle-btn"
              [class.active]="
                audioAnalyzerService.audioSettings.echoCancellation
              "
              (click)="toggleEchoCancellation()"
              title="エコーキャンセレーション切替"
            >
              EC:
              {{
                audioAnalyzerService.audioSettings.echoCancellation
                  ? 'ON'
                  : 'OFF'
              }}
            </button>
            <button
              type="button"
              class="setting-toggle-btn"
              [class.active]="
                audioAnalyzerService.audioSettings.noiseSuppression
              "
              (click)="toggleNoiseSuppression()"
              title="ノイズサプレッション切替"
            >
              NS:
              {{
                audioAnalyzerService.audioSettings.noiseSuppression
                  ? 'ON'
                  : 'OFF'
              }}
            </button>
            <button
              type="button"
              class="setting-toggle-btn"
              [class.active]="
                audioAnalyzerService.audioSettings.autoGainControl
              "
              (click)="toggleAutoGainControl()"
              title="オートゲインコントロール切替"
            >
              AGC:
              {{
                audioAnalyzerService.audioSettings.autoGainControl
                  ? 'ON'
                  : 'OFF'
              }}
            </button>
          </div>
        </div>
        <!-- デバッグJSON注入UI -->
        <div class="debug-json-inject">
          <div class="control-group">
            <span class="control-label">JSON Inject:</span>
          </div>
          <textarea
            class="debug-json-textarea"
            [(ngModel)]="debugJsonInput"
            rows="12"
            spellcheck="false"
          ></textarea>
          <div class="debug-json-actions">
            <button type="button" class="inject-btn" (click)="onInjectJson()">
              Inject
            </button>
            @if (debugJsonError) {
              <div class="debug-json-error">
                {{ debugJsonError }}
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!--
      <div class="mic" [class.user]="state==='USER_SPEAKING' || state==='LISTENING'" [class.processing]="state==='PROCESSING'"
        [class.ai]="state==='AI_SPEAKING'">
        <div class="ring"></div>
        <div class="icon">
          <span class="ico">{{ micIcon }}</span>
          <div class="audio-level-display ring-overlay" *ngIf="state==='USER_SPEAKING' || state==='LISTENING'">
            <div class="listening-ring" role="img">
              <svg viewBox="0 -4 120 126" aria-hidden="true">
                <circle class="ring-bg" [attr.cx]="ringCx" [attr.cy]="ringCy" [attr.r]="ringR" />
                <path class="ring-wave" [attr.d]="wavePath" aria-hidden="true" />
              </svg>
            </div>
          </div>
        </div>
        -->
    <!-- 字幕テキスト表示 -->
    @if (captionsFeatureEnabled && captionsEnabled) {
      <div class="captions-container" aria-live="polite" aria-atomic="true">
        @if (userSubtitle || aiSubtitle) {
          <div class="captions-text">
            @if (userSubtitle) {
              <div class="captions-line captions-user">
                <span class="captions-label">ユーザー</span>
                <span class="captions-content">{{ userSubtitle }}</span>
              </div>
            }
            @if (aiSubtitle) {
              <div class="captions-line captions-ai">
                <span class="captions-label">{{ personaDisplayName }}</span>
                <span class="captions-content">{{ aiSubtitle }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}

<!-- 履歴画面 -->
@if (view === 'HISTORY') {
  <div class="page view-container fade-in">
    @if (selectedPersona; as p) {
      <div class="prepare-stack">
        <section class="history-container">
          <div class="conversation-header">
            <div class="header-left">
              <h2>{{ sessionTitle }}</h2>
              <h4>{{ p.name }} ({{ p.literacyLevel }}・{{ p.occupation }})</h4>
              <p class="audio-duration-info">
                会話時間: {{ sessionDurationSeconds }}秒
                @if (!canCreateAssessment) {
                  <span class="warning-text">
                    （アセスメント作成には90秒以上必要です）
                  </span>
                }
              </p>
            </div>
            <!-- アセスメント結果確認リンク（クエリパラメータ付き） -->
            @if (canCreateAssessment) {
              <span>
                @if (assessmentId && userId) {
                  <a
                    class="item assessment-btn"
                    [routerLink]="['/home']"
                    [queryParams]="assessmentResultQueryParams"
                  >
                    アセスメント画面を開く
                  </a>
                }
                <!-- アセスメントID待機中 -->
                @if (!assessmentId) {
                  <div class="assessment-loading">アセスメント作成中...</div>
                }
                <!-- ユーザーID取得できない場合 -->
                @if (assessmentId && !userId) {
                  <div class="assessment-loading">ユーザー情報取得中...</div>
                }
              </span>
            }
            @if (!canCreateAssessment) {
              <button
                class="assessment-btn disabled"
                type="button"
                disabled
                [title]="
                  '会話時間が90秒未満のため、アセスメントを作成できません（現在: ' +
                  sessionDurationSeconds +
                  '秒）'
                "
              >
                アセスメント作成不可
              </button>
            }
          </div>
          @if (conversations.length) {
            <div class="conversation-messages">
              @for (m of conversations; track m; let i = $index) {
                <!-- assessmentエントリはスキップ（AIメッセージに統合表示） -->
                @if (m.type !== 'assessment') {
                  <div
                    class="conversation-row"
                    [class.user]="m.type === 'user'"
                    [class.ai]="m.type === 'ai'"
                  >
                    <!-- AI吹き出し外側上方の評価表示（アドオン注入） -->
                    @if (
                      m.type === 'ai' &&
                        historyAssessmentComponent &&
                        getAssessmentForAiMessage(i);
                      as assessData
                    ) {
                      <ng-container
                        *ngComponentOutlet="
                          historyAssessmentComponent;
                          inputs: { assessment: assessData }
                        "
                      ></ng-container>
                    }
                    <div
                      class="bubble"
                      [class.user]="m.type === 'user'"
                      [class.ai]="m.type === 'ai'"
                    >
                      <div class="meta">
                        <span class="who">{{
                          m.type === 'user'
                            ? '営業担当者'
                            : getSpeakerForAiMessage(i)
                        }}</span>
                      </div>
                      <div class="content">{{ m.content }}</div>
                    </div>
                  </div>
                }
              }
            </div>
          } @else {
            <div class="empty-state">会話履歴なし</div>
          }
        </section>
      </div>
    }
  </div>
}

<!-- 独自UIのダイアログ -->
@if (alertConfig) {
  <div
    class="custom-alert-overlay"
    (click)="hideAlert()"
    (keyup.enter)="hideAlert()"
    (keyup.space)="hideAlert()"
    tabindex="0"
    role="button"
    aria-label="Close dialog"
  >
    <div
      class="custom-alert"
      (click)="$event.stopPropagation()"
      (keyup.enter)="$event.stopPropagation()"
      (keyup.space)="$event.stopPropagation()"
      tabindex="0"
      role="alertdialog"
      aria-labelledby="alert-message"
    >
      <div id="alert-message" class="alert-message">
        {{ alertConfig.message }}
      </div>
      <div class="alert-buttons">
        @if (alertConfig.type === 'confirm') {
          <button class="alert-btn confirm" (click)="confirmAlert()">
            {{ alertConfig.confirmText }}
          </button>
        }
        @if (alertConfig.type === 'confirm') {
          <button class="alert-btn cancel" (click)="hideAlert()">
            {{ alertConfig.cancelText }}
          </button>
        }
        @if (alertConfig.type !== 'confirm') {
          <button class="alert-btn ok" (click)="hideAlert()">OK</button>
        }
      </div>
    </div>
  </div>
}
